import React from 'react';
import { IOldIconProps } from './type';

const UserFilled: React.FC<IOldIconProps> = ({
  width = 24,
  height = 25,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.7792 4.0835C8.87973 4.0835 6.52922 6.434 6.52922 9.3335C6.52922 10.6691 7.02793 11.8882 7.84929 12.8147C6.10966 14.1116 4.63229 16.1893 3.82515 18.6847C3.50606 19.6711 4.28084 20.5835 5.23322 20.5835H18.3252C19.2776 20.5835 20.0524 19.6711 19.7333 18.6847C18.9262 16.1893 17.4488 14.1116 15.7092 12.8147C16.5305 11.8881 17.0292 10.6691 17.0292 9.3335C17.0292 6.434 14.6787 4.0835 11.7792 4.0835Z"
      fill="black"
    />
  </svg>
);

export default UserFilled;
